import axios from 'src/utils/axios';
import { addNotification } from 'src/actions/notificationActions';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';

export const GET_TEXTING_OPT_IN_DATA = '@texting-opt-in/get-texting-opt-in-data';
export const GET_TEXTING_OPT_IN_DATA_SUCCESS = '@texting-opt-in/get-texting-opt-in-data-success';
export const GET_TEXTING_OPT_IN_DATA_ERROR = '@texting-opt-in/get-texting-opt-in-data-error';

export const SUBMIT_TEXTING_OPT_IN = '@texting-opt-in/submit-texting-opt-in';
export const SUBMIT_TEXTING_OPT_IN_SUCCESS = '@texting-opt-in/submit-texting-opt-in-success';
export const SUBMIT_TEXTING_OPT_IN_ERROR = '@texting-opt-in/submit-texting-opt-in-error';

export const getTextingOptInData = (slug) => async (dispatch) => {
  dispatch({
    type: GET_TEXTING_OPT_IN_DATA,
  });
  try {
    const response = await axios.get(`/api/texting/o/${slug}`);
    dispatch({
      type: GET_TEXTING_OPT_IN_DATA_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_TEXTING_OPT_IN_DATA_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_TEXTING_OPT_IN_DATA_ERROR,
    });
  }
};

export const submitTextingOpt = (sendData, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SUBMIT_TEXTING_OPT_IN,
    });
    const response = await axios.post('/api/texting/o/accept', sendData);
    const {
      success,
      message,
    } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SUBMIT_TEXTING_OPT_IN_ERROR, 'Could not confirm your opt-in', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SUBMIT_TEXTING_OPT_IN_ERROR,
      });
      return;
    }

    dispatch(addNotification(SUBMIT_TEXTING_OPT_IN_SUCCESS, 'You have successfully opted in', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SUBMIT_TEXTING_OPT_IN_SUCCESS,
      payload: message || {},
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SUBMIT_TEXTING_OPT_IN_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SUBMIT_TEXTING_OPT_IN_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};
